<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="640">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small text v-bind="attrs" v-on="on">
          Create User
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          Register User
        </v-card-title>

        <v-card-text>
          <v-form ref="frmRegister">
            <v-text-field required v-model="user.email" label="Email address" :rules="emailRules"></v-text-field>
            <v-text-field required v-model="user.password" placeholder="Password" type="password" :rules="passwordRules" :counter="20"></v-text-field>
            <v-text-field required v-model="user.passwordConfirm" placeholder="Confirm Password" :rules="passwordConfirmRules" type="password">
            </v-text-field>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="createUser">
            Create User
          </v-btn>
          <v-btn color="error" @click="resetForm">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        user: {
          email: '',
          password: '',
          passwordConfirm: ''
        },
        // Form Verification
        valid: false,
        passwordRules: [
          v => !!v || 'Password is required',
          v => v.length >= 10 || 'Password must be at least 10 characters',
        ],
        passwordConfirmRules: [v => v == this.user.password || 'Passwords must match.'],
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid',
        ],
        dialog: false,
      }
    },
    methods: {
      createUser() {
        if(this.$refs.frmRegister.validate()) {
          this.$axios.post('/register', this.user).then(res => {
            if(res.data.status === 'error'){
              this.$toastr.e(res.data.message)
              return false
            }
            this.$toastr.s("Created new user " + this.user.email)
            this.resetForm()
          }).catch(err => {
            this.$toastr.e(err.message)
            console.log(err)
          })
        }
      },
      resetForm(){
        this.user = {
          email: '',
          password: '',
          passwordConfirm: ''
        }
        this.dialog = false
      }
    }
  }
</script>